import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import { deepDelete } from '@/helpers/deepDelete'
import {
  QUERY_RAFFLE_BY_ID,
  QUERY_RAFFLE_ON_APPROVAL_BY_ID,
  QUERY_LUCKY_NUMBERS_METRICS,
  MUTATION_CREATE_RAFFLE,
  MUTATION_CREATE_RAFFLE_DRAFT,
} from '../graphql'

export default {
  async getRaffle({ state, commit }, context) {
    const { apollo, raffleId } = context
    const response = await apollo.query({
      query: QUERY_RAFFLE_BY_ID,
      variables: {
        raffle_id: raffleId,
      },
      fetchPolicy: 'no-cache',
    })
    const registerNumber = Number(response.data.getRaffleById.register_number)
    if (!response.data.getRaffleById.segments) {
      response.data.getRaffleById.segments = []
    }
    if (!response.data.getRaffleById.exclusion_segments) {
      response.data.getRaffleById.exclusion_segments = []
    }
    if (typeof registerNumber === 'number') response.data.getRaffleById.register_number = registerNumber
    commit('SET_OBJECT', { name: 'raffle', data: response.data.getRaffleById, state })
    return response
  },
  async getRaffleOnApproval({ state, commit }, context) {
    const { apollo, raffleId } = context
    const response = await apollo.query({
      query: QUERY_RAFFLE_ON_APPROVAL_BY_ID,
      variables: {
        raffle_id: raffleId,
      },
      fetchPolicy: 'no-cache',
    })
    const registerNumber = Number(response.data.getRaffleOnApprovalById.register_number)
    if (!response.data.getRaffleOnApprovalById.segments) {
      response.data.getRaffleOnApprovalById.segments = []
    }
    if (!response.data.getRaffleOnApprovalById.exclusion_segments) {
      response.data.getRaffleOnApprovalById.exclusion_segments = []
    }
    if (typeof registerNumber === 'number') response.data.getRaffleOnApprovalById.register_number = registerNumber
    commit('SET_OBJECT', { name: 'raffle', data: response.data.getRaffleOnApprovalById, state })
    return response
  },
  setRaffle({ state, commit }, raffle) {
    return commit('SET_OBJECT', { name: 'raffle', data: raffle, state })
  },
  async getRaffleLuckyNumbersMetrics({ state, commit }, context) {
    const { apollo, raffleId } = context
    const response = await apollo.query({
      query: QUERY_LUCKY_NUMBERS_METRICS,
      variables: {
        raffleId,
      },
      fetchPolicy: 'no-cache',
    })
    commit('SET_OBJECT', { name: 'luckyNumbersMetrics', data: response.data.raffleLuckyNumbersMetrics, state })
    return response
  },
  async upsertRaffle({ state }, context) {
    const { apollo, isDraft } = context
    let mutation
    if (isDraft) {
      mutation = MUTATION_CREATE_RAFFLE_DRAFT
    } else {
      mutation = MUTATION_CREATE_RAFFLE
    }
    const formattedRaffle = cloneDeep(state.raffle)
    deepDelete(formattedRaffle, ['__typename', 'status', 'show_prize_warning', 'formattedUpdateDate', 'on_approval'])
    if (isDraft) {
      formattedRaffle.draft = true
    }
    if (formattedRaffle?.segments) {
      formattedRaffle.segments = formattedRaffle.segments.map((segment) => segment._id)
    }
    if (formattedRaffle?.exclusion_segments) {
      formattedRaffle.exclusion_segments = formattedRaffle.exclusion_segments.map((segment) => segment._id)
    }
    if (!formattedRaffle.optin.active) {
      formattedRaffle.optin.terms = ''
    }
    if (!formattedRaffle.app_start_exhibition_date) {
      formattedRaffle.app_start_exhibition_date = moment().format('YYYY-MM-DD')
    }
    if (!formattedRaffle.app_end_exhibition_date) {
      formattedRaffle.app_end_exhibition_date = moment().add(1, 'week').format('YYYY-MM-DD')
    }
    formattedRaffle.max_numbers_per_person = parseInt(formattedRaffle.max_numbers_per_person) ?? null
    formattedRaffle.max_numbers_per_coupon = parseInt(formattedRaffle.max_numbers_per_coupon) ?? null
    if (typeof formattedRaffle.rules.value === 'string') {
      formattedRaffle.rules.value = +parseFloat(formattedRaffle.rules.value.replaceAll('.', '').replace(',', '.')) ?? null
    }
    if (typeof formattedRaffle.register_number === 'number') {
      formattedRaffle.register_number = `${formattedRaffle.register_number}`
    }
    if (!formattedRaffle.available_in_app) {
      formattedRaffle.app_start_exhibition_date = ''
      formattedRaffle.app_end_exhibition_date = ''
    }
    formattedRaffle.prizes.map((prize) => {
      prize.quantity = parseInt(prize.quantity) ?? null
    })
    formattedRaffle.units = formattedRaffle.units.map((unit) => {
      if (unit.id_erp) return unit.id_erp
      return unit
    })
    const skus = []
    formattedRaffle.rules.products.map((item) => {
      if (!item.products) {
        skus.push(item.sku)
      } else {
        item.products.map((product) => {
          skus.push(product.sku)
        })
      }
    })
    formattedRaffle.rules.products = skus
    if (formattedRaffle.rules.product_groups) {
      formattedRaffle.rules.product_groups = formattedRaffle.rules.product_groups.map((productGroup) => ({
        uuid: productGroup.uuid,
        active: productGroup.active,
        name: productGroup.name,
        image_url: productGroup.image_url,
        trigger_value: productGroup.trigger_value,
        acceleration_value: productGroup.acceleration_value,
        ...(productGroup.max_per_coupon_value
          ? {
              max_per_coupon_value: parseInt(productGroup.max_per_coupon_value),
            }
          : {}),
        products: productGroup.products?.map((product) => product.sku),
      }))
    }
    return apollo.mutate({
      mutation: mutation,
      variables: {
        raffle: formattedRaffle,
      },
    })
  },
}
